
import { registerBlockType } from '@quillforms/blocks';
import Element from './dropdown';

registerBlockType('custom-dropdown', {
	"attributes": {
		"choices": {
			"type": "array",
			"items": {
				"type": "object",
				"properties": {
					"value": {
						"type": "string"
					},
					"label": {
						"type": "string"
					}
				}
			},
			"default": [
				{
					"value": "123e45z7o89b",
					"label": "Choice 1"
				}
			]
		},
        defaultValue: {
            type: 'string',
        },
	},
	"supports": {
		"editable": true,
		"required": true,
		"attachment": true,
		"description": true,
		"logic": true,
		"theme": true,
		"points": true,
		"payments": true,
		"choices": true
	},
	"logicalOperators": [
		"is",
		"is_not"
	],

  display: (props) => <Element {...props} />
});

